export default "__VITE_ASSET__EjiT93TD__"